var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileScreen)?_c('carouselMobile',_vm._b({},'carouselMobile',_vm.$attrs,false)):_c('carouselPC',_vm._b({},'carouselPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }